import clsx from 'clsx';
import { Fragment, useCallback } from 'react';

import { Link } from '@/components/common/link';
import Route from '@/config/routes/types';

type MenuLink = {
  title: string;
  badge?: string;
  to?: string;
  href?: string;
};

const menuLinks: MenuLink[] = [
  {
    title: 'Platform',
    to: Route.CONTACT_US
  },
  {
    title: 'Tanglius',
    href: '#top'
  },
  {
    title: 'Use cases',
    href: '#use-cases',
    badge: 'Coming soon'
  },
  {
    title: 'Contact us',
    href: '#contact-us'
  }
];

const menuAgreements = [
  {
    title: 'Terms & Conditions',
    to: Route.TERMS_AND_CONDITIONS
  }
  // {
  //   title: 'Privacy',
  //   to: Route.PRIVACY
  // }
];

interface LandingLayoutSidebarMenuProps {
  isOpened: boolean;
  onClose: () => void;
}

export const LandingLayoutSidebarMenu = ({
  isOpened = false,
  onClose
}: LandingLayoutSidebarMenuProps) => {
  const handleClose = useCallback(onClose, [onClose]);

  return (
    <div className="flex flex-col gap-36 pt-8 px-7.75 pb-4">
      <div className="flex flex-col">
        {menuLinks.map(({ title, badge, ...linkProps }, idx) => (
          <Fragment key={idx}>
            <Link
              classes={clsx(
                'inline-flex items-center gap-3 truncate cursor-pointer hover:text-mantis transition-colors ease-out duration-300',
                isOpened ? 'text-opacity-100' : 'text-opacity-0'
              )}
              noUnderline
              onClick={handleClose}
              variant="primary"
              {...linkProps}
            >
              <span>{title}</span>
              {badge && (
                <span className="px-2 py-0.5 rounded-full border border-mantis/40 bg-mantis/10 text-mantis text-xs font-mono tracking-wider uppercase">
                  {badge}
                </span>
              )}
            </Link>
          </Fragment>
        ))}
      </div>

      <div className="flex flex-col">
        {menuAgreements.map(({ title, ...linkProps }, idx) => (
          <Fragment key={idx}>
            <Link
              classes={clsx(
                'truncate cursor-pointer hover:text-mantis transition-colors ease-out duration-300',
                isOpened ? 'text-opacity-100' : 'text-opacity-0'
              )}
              noUnderline
              onClick={handleClose}
              variant="secondary"
              {...linkProps}
            >
              {title}
            </Link>
          </Fragment>
        ))}
      </div>
    </div>
  );
};
